export default __webpack_public_path__ + "static/media/Overline Mark.3f21cf6c.svg";